import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';
import { useDebounce } from 'use-debounce';

import { IPublicDesktopV1FiltersGetMetaResponse } from 'shared/repositories/commercial-search-offers/desktop/v1/filters/get-meta';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { useJsonQuery } from 'shared/utils/hooks/useJsonQuery';

import { QueryError, QueryKey, getQueryKey } from './internal/config';
import { fetchPublicDesktopV1FiltersGetCountService } from './internal/fetchService';

export function useGetCountQuery(
  options?: UseQueryOptions<IPublicDesktopV1FiltersGetMetaResponse, QueryError, number, QueryKey>,
): UseQueryResult<number, QueryError> {
  const context = useApplicationContext();
  const jsonQuery = useJsonQuery();

  const [debouncedJsonQuery] = useDebounce(jsonQuery, 300);

  return useQuery<IPublicDesktopV1FiltersGetMetaResponse, QueryError, number, QueryKey>({
    keepPreviousData: true,
    queryFn: () => fetchPublicDesktopV1FiltersGetCountService(context, { jsonQuery }),
    queryKey: getQueryKey({ jsonQuery: debouncedJsonQuery }),
    select: data => data.data.count,
    ...options,
  });
}
